module.exports = require("./ar-SY");